import {Component, OnInit} from '@angular/core';
import {AlertController, App, NavController, NavParams, ToastController} from 'ionic-angular';
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {GlobalProvider} from "../../providers/global/global";
import {AuditService} from "../../store/audit/audit.service";
import {Subscription} from "rxjs/Subscription";
import {AuditEntity} from "../../store/audit/audit.entity";

/**
 * Generated class for the PruefungAllgemeinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
// @IonicPage({
//   segment: 'allgemein'
// })
@Component({
  selector: 'page-pruefung-allgemein',
  templateUrl: 'pruefung-allgemein.html',
})
export class PruefungAllgemeinPage {

  public isBrowser: boolean = false;
  public isCordova: boolean = false;
  public createdDate: any = new Date().toISOString();
  public pruefung: AuditEntity = null;
  public isOwner: boolean = false;

  private _subscription: Subscription;


  constructor(public navCtrl: NavController,
              public appCtrl: App,
              public navParams: NavParams,
              // private dataProvider: DataProvider,
              private toastCtrl: ToastController,
              private alertCtrl: AlertController,
              public globalProvider: GlobalProvider,
              private auditService: AuditService
  ) {

      let navctrl:any = this.navCtrl;
      let segments = navctrl._linker.getCurrentSegments();
      for(let segment of segments){
        for(let paramName in segment.data){
          this.navParams.data[paramName] = segment.data[paramName];
        }
      }



    this.isBrowser = this.globalProvider.isBrowser();
    this.isCordova = this.globalProvider.isCordova();
  }

  ionViewDidLoad() {
    let pruefungId = this.navParams.get('pruefungId');
    this._subscription = this.auditService.getById(pruefungId)
      .subscribe((audit) => {
        this.pruefung = audit;
        this.isOwner = this.pruefung.ownerId === this.globalProvider.user.uuid;
        if(!this.pruefung.hasOwnProperty('besuchszeit')){
          this.pruefung['besuchszeit'] = {von: null, bis: null};
        }
      });
  }

  ionViewWillLeave(){
    this._subscription.unsubscribe();
  }

  public save(): void {
    this.auditService.set(this.pruefung, false);
  }

  public delete(): void {
    //todo: abfrage ob wirklich gelöscht werden soll. zu löschen sind alle prüfprotokolle und die dazugehörigen attachments(bilder) und die prüfung
    let alert = this.alertCtrl.create({
      title: 'Pruefung löschen?',
      message: 'Möchten Sie die Prüfung und die darin befindlichen Protokolle wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Ja',
          handler: () => {
            console.log('Agree clicked');
            this._deletePruefung();
            this.appCtrl.getRootNav().goToRoot();
            // this.navCtrl.goToRoot({});
          }
        }
      ]
    });

    alert.present();
  }

  private _deletePruefung(): void {
    this.pruefung.protokolle.forEach((protokollId) => {
      //todo: noch die protokolle die an dieser Prüfung hängen löschen.
      // this.dataProvider.softDeleteDocumentById(protokollId);
    });
    this.auditService.remove(this.pruefung);
  }

  public duplicate():void {
    //todo: prüfung duplizieren wenn mindestens ein Prüfprotokoll vorhanden ist, ansonsten Meldung für user, dass duplizieren nicht möglich, da keine protokolle in dieser prüfung vorhanden sind
    if(this.pruefung.protokolle.length === 0){
      this.toastCtrl.create({
        message: 'Duplizieren nicht möglich, da diese Prüfung keine Protokolle beinhaltet!',
        duration: 3000,
        position: 'bottom'
      }).present();
    }
  }

  public saveNextCheckDate():void {

  }
}



// WEBPACK FOOTER //
// ./src/pages/pruefung-allgemein/pruefung-allgemein.ts